export const environment = {
    production: false,
    environmentName : 'qat',
    serverUrl : 'https://idr-qat.umgc.edu',
    ssoUrl : 'https://login.microsoftonline.com/704ce3d6-a4bf-4e09-8516-d52840c9f7a9/oauth2/v2.0/authorize',
    clientUrl : 'https://crmia-qat.umgc.edu',
    ssoOn : false,
    clientId : '210cf47f-29b9-4038-a004-578c07613d28'
  };
  